const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  data() {
    return {
      valid: false,
      profile: {},
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
        email: value => pattern.test(value) || 'Поле E-mail заполнено с ошибками',
      },
      search: '',
      cities: [],
      specialties: [],
      dealers: [],
      searchDealer: '',
      searchDealerObj: null,
      dialog: false,
      password: '',
      passwordConfirm: '',
      hidePw: true,
    };
  },
  computed: {
    user() { return this.$store.state.user; },
    account() { return this.$store.state.user.account; },
    taxes() { return this.$store.state.settings.taxes === true; },
    isApproved() { return !!(this.$store.getters.isApproved); },
    token() { return this.$store.state.token; },
    isAuthenticated() { return this.$store.getters.isAuthenticated; },
    loading() { return this.$store.state.loading; },
    settings() { return this.$store.state.settings; },
    changePasswordValid() {
      return !!(this.password && this.passwordConfirm && this.password === this.passwordConfirm);
    },
  },
  methods: {
    createUser() {
      this.profile = { ...this.user };
      if (this.user.dealer) {
        this.dealers.push(this.user.dealer);
      }
    },
    ClearDialog() {
      this.dialog = false;
      this.password = '';
      this.passwordConfirm = '';
      this.hidePw = true;
    },
    ChangePassword() {
      if (!this.changePasswordValid) {
        return;
      }
      const app = this;
      const payload = {
        token: app.token,
        profile_id: app.profile.profile_id,
        password: app.password,
        passwordConfirm: app.passwordConfirm,
      };
      app.$store.getters.axl.post('profiles/api/v3/change-password', payload)
        .then(() => {
          app.$store.dispatch('ShowInfo', 'Ваш пароль был успешно обновлён');
          app.ClearDialog();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    profileSubmit() {
      const app = this;
      if (this.$refs.form.validate() && this.isAuthenticated) {
        const profile = {
          profile_id: app.profile.profile_id,
          dealer_id: app.profile.dealer_id,
          last_name: app.profile.last_name,
          first_name: app.profile.first_name,
          middle_name: app.profile.middle_name,
          email: app.profile.email,
          birthday_on: app.profile.birthday_on,
          city_local: app.profile.city_local,
          gender: app.profile.gender,
          specialty: app.profile.specialty,
          role: app.profile.role,
        };
        app.$store.getters.axl.post('profiles/api/auth/profile-edit', profile)
          .then(() => {
            app.$store.dispatch('ShowInfo', 'Ваш профиль был успешно обновлён');
            this.$router.push({ name: 'dashboard' });
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          });
      } else {
        app.$store.dispatch('HandleError', 'Ошибка отправки формы');
      }
    },
  },
  watch: {
    search(val) {
      if (val) {
        this.$store.getters.ax.post('location/api/cities/autocomplete', { term: val })
          .then((result) => {
            this.cities = result.data.cities;
          });
      }
    },
    searchDealer(name) {
      name && this.$store.getters.ax.post('profiles/api/register/autocomplete-company', { name })
        .then((result) => {
          this.dealers = result.data.dealers;
        });
    },
  },
  mounted() {
    if (this.isAuthenticated) {
      this.$store.dispatch('eps/GetOrders', this.user.profile_id);
      this.createUser();
    }
  },
};
